module.exports = __webpack_public_path__ + "static/media/icon-success.25c78307.svg";